import React from 'react';
import { Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import { createStyles } from 'antd-style';
import { useTranslation } from 'react-i18next';
import IconPerson from 'ui-component/icons/personl2';
import IconLogout from 'ui-component/icons/logout';
import { userLogout } from 'controller/auth';
import Notify from 'ui-component/Tools/Notify';
import Storage from 'utils/storage';

export const useStyles = createStyles(({ token, css }) => {
  return {
    circle: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      background: '#a7a9c0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      cursor: 'pointer'
    },
    item: css`
      display: flex;
      align-items: center;
      transition: all 0.3s;
      border-radius: 4px;
      padding: 8px;
      cursor: pointer;
      &:hover {
        background-color: rgba(242, 246, 255, 1);
      }
    `,
    name: css`
      font-size: 14px;
      margin-left: 12px;
    `
  };
});

const CMP = () => {
  const { styles } = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  const userlogout = async () => {
    const res = await userLogout();
    if (res.success) {
      Notify('success', t('tips.logout', { ns: 'common' }));
      Storage.clear();
      navigate('/login');
    }
  };

  const content = (
    <div>
      <div className={styles.item} onClick={userlogout}>
        <IconLogout width={20} height={20} />
        <div className={styles.name}>{t('logout', { ns: 'common' })}</div>
      </div>
    </div>
  );
  return (
    <Popover content={content} trigger="hover">
      <div className={styles.circle}>{t('me', { ns: 'common' })}</div>
    </Popover>
  );
};

export default CMP;
